import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import {
  Router,
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router';

@Injectable()
export class LoadingService {

  private loading = new BehaviorSubject(true);
  currentLoading = this.loading.asObservable();

  constructor(private router: Router) {
    router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });
  }

  changeLoading(load: boolean) {
    this.loading.next(load);
  }

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.loading.next(true);
    }

    if (event instanceof NavigationEnd) {
      this.loading.next(false);
    }

    if (event instanceof NavigationCancel) {
      this.loading.next(false);
    }
    if (event instanceof NavigationError) {
      this.loading.next(false);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loading.service.ts